<template>
  <div class="app-camera-tool">
    <div
      ref="videoContainer"
      :style="{ width: newWidth + 'px', height: height + 'px' }"
      class="camera-container"
    />

    <div class="navigation-bar">
      <div
        class="navigation-bar__item"
        @click="$router.go(-1)"
      >
        <v-btn
          icon
          dark
        >
          <v-icon dark>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </div>
      <div
        class="navigation-bar__item"
        @click="snap"
      >
        <v-btn
          icon
          dark
        >
          <v-icon
            x-large
            dark
          >
            mdi-camera
          </v-icon>
        </v-btn>
      </div>
      <div class="navigation-bar__item">
        <v-btn
          icon
          dark
        >
          <v-icon dark>
            mdi-cached
          </v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { Webcam } from "./test";

export default {
  name: "AppCameraTool",

  props: {
    width: {
      type: Number,
      default: 200
    },

    height: {
      type: Number,
      default: 850
    }
  },

  computed: {
    newWidth() {
      return this.height / 1.333333333333333; // TODO: Put this on store
    }
  },

  mounted() {
    Webcam.set({
      image_format: "png",
      jpeg_quality: 90
    });

    Webcam.init();
    Webcam.attach(this.$refs.videoContainer);
  },

  beforeDestroy() {
    Webcam.reset();
  },

  methods: {
    snap() {
      Webcam.snap(data_uri => {
        this.$store.commit("medias/SET_BACKGROUND_LAYER", data_uri);
        this.$router.go(-1);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.app-camera-tool {
  background-color: #000;
  height: 100%;
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;

  .navigation-bar {
    display: flex;
    justify-content: space-evenly;
    align-content: center;
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    background-color: transparent;

    &__item {
      padding: 20px;
    }
  }
}
</style>
